import * as CryptoJS from 'crypto-js';
import * as R from 'ramda';

import { Button, OverlayTrigger } from 'react-bootstrap';
import { IAIEarth, IAir, IMap } from '../../store/aiearth/types';
import { IElasticResult, ISearchRecord, dummyRecord } from '../../types/search';
import React, { Fragment, useEffect, useState } from 'react';
import Slide, { SlideProps } from '@material-ui/core/Slide';
import { iv, key as secKey } from '../../services/firebase';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { updateAIEarth, updateAir } from '../../store/aiearth/action';
import { useDispatch, useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CeresLogger } from '../../logger';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import Fade from '@material-ui/core/Fade';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { IAuthContext } from '../../context/auth/auth-context';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import LinearProgress from '@material-ui/core/LinearProgress';
import ListSubheader from '@material-ui/core/ListSubheader';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Parser from 'rss-parser';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { Scrollbars } from 'react-custom-scrollbars';
import SearchIcon from '@material-ui/icons/Search';
import SearchPagination from './SearchPagination';
import Switch from '@material-ui/core/Switch';
import { Table } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import { TwitterTweetEmbed } from 'react-twitter-embed';
import { VariableSizeList } from 'react-window';
import { applyFilterToQuery } from '../../pages/ai-earth/index';
import axios from 'axios';
import { search } from '../../services/firebase';
import styled from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import withAuthContext from '../../context/auth/AuthConsumer';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { API_BASE_URL, API_AUTH_HEADERS } from '../../util/api.util';
import ReactGA from 'react-ga4';

interface IAiEarthTab {
  getAirLists: () => void;
  boundingBox: any;
  setBoundingBox: any;
  coords: any;
  setActiveTabDrawer: any;
  ProgramQuery: React.StatelessComponent;
  setSearchTerm: any;
  searchTerm: string;
}
const TypographyCustom = styled.span`
  font-size: 8px;
  font-weight: 600;
`;

const AirContainer = styled.div`
  margin: 5px;
  .MuiFormGroup-root {
    margin: 15px 0 5px !important;
  }
  .MuiFormControlLabel-root {
    margin-right: 12px !important;
  }
  .MuiRadio-root {
    padding: 2px !important;
    color: #94a3b8 !important;
  }
  .MuiRadio-colorSecondary.Mui-checked {
    color: #94a3b8 !important;
  }
  .MuiTypography-body1 {
    font-size: 14px !important;
    color: #94a3b8 !important;
  }
  .MuiFormLabel-root {
    color: #94a3b8 !important;
  }
  .MuiFormLabel-root.Mui-focused {
    color: #94a3b8 !important;
  }
  .MuiOutlinedInput-root {
    color: #ecf0f5 !important;
    border-radius: 8px !important;
  }
  .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: rgba(148, 163, 184, 0.45) !important;
  }
  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(148, 163, 184, 0.75) !important;
  }
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #94a3b8 !important;
    border-width: 1px !important;
  }
  .MuiInputAdornment-root .MuiIconButton-root {
    color: #94a3b8 !important;
  }
  .cmn-air-keyword-input .MuiOutlinedInput-root {
    background-color: #000 !important;
  }
  .cmn-air-keyword-input .MuiOutlinedInput-input {
    color: #60a5fa !important;
  }
  .cmn-air-keyword-input .MuiInputAdornment-root .MuiIconButton-root {
    width: 34px !important;
    height: 34px !important;
    border-radius: 8px !important;
    background: #34d399 !important;
    color: #04130f !important;
    margin-right: 2px !important;
  }
  .cmn-air-keyword-input .MuiInputAdornment-root .MuiIconButton-root:hover {
    background: #5eead4 !important;
  }

  .cmn-air-pill-option {
    margin-right: 10px !important;
    margin-bottom: 8px !important;
    border: 1px solid rgba(148, 163, 184, 0.22);
    border-radius: 10px;
    background: rgba(2, 7, 13, 0.88);
    padding: 4px 12px 4px 8px;
    min-height: 38px;
    transition: border-color 0.15s ease, background 0.15s ease;
  }

  .cmn-air-pill-option .MuiRadio-root {
    display: none;
  }

  .cmn-air-pill-option .MuiFormControlLabel-label {
    color: #e2e8f0 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }

  .cmn-air-pill-option__label {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }

  .cmn-air-pill-option__label::before {
    content: '';
    width: 13px;
    height: 13px;
    border-radius: 3px;
    border: 1px solid rgba(255, 255, 255, 0.85);
    background: transparent;
    color: transparent;
    font-size: 10px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .cmn-air-pill-option--active {
    border-color: #34d399;
    background: rgba(2, 7, 13, 0.88);
  }

  .cmn-air-pill-option--active .cmn-air-pill-option__label::before {
    content: '✓';
    border-color: #34d399;
    background: #34d399;
    color: #052e16;
  }
`;
const BoundingBox = styled.p`
  font-size: 14px;
  margin-top: 20px;
  margin-bottom: 0;
  color: #6c757d;
  margin: 5px 15px 10px 15px;
`;

const PopupContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;
const RecordsContainer = styled.div`
  padding-right: 10px;
`;

const SearchResultContainer = styled.div`
  padding: 10px 5px;
`;
const Dialogs = styled(Dialog)`
  z-index: 9999 !important;
`;
const PopoverContainer = styled.div`
  border: 1px solid rgba(148, 163, 184, 0.24);
  background: linear-gradient(180deg, rgba(2, 7, 13, 0.96) 0%, rgba(3, 10, 19, 0.96) 100%);
  border-radius: 12px;
  padding: 10px;
  font-size: 12px;
  color: #94a3b8;

  .table {
    color: #94a3b8;
    background: transparent;
    margin-bottom: 0;
  }

  .table td,
  .table th {
    border-color: rgba(148, 163, 184, 0.25);
    color: #94a3b8;
    background: rgba(2, 7, 13, 0.72);
  }

  a {
    color: #5eead4;
  }
`;

const TweetContainer = styled.div`
  padding: 0px 12px;
`;

const EmissionTR = styled.tr`
  background-color: rgba(15, 23, 42, 0.62);
  color: #94a3b8;
  font-weight: 600;
`;

const CenterTD = styled.td`
  vertical-align: middle !important;
  text-align: center;
`;

const FixedTD = styled.td`
  width: 8em;
`;

const NewsHeader = styled.h4`
  background: rgba(52, 211, 153, 0.14);
  border: 1px solid rgba(52, 211, 153, 0.4);
  border-radius: 10px;
  padding: 10px 15px 12px;
  color: #d1fae5;
  text-align: center;
  a {
    color: #d1fae5;
    text-decoration: underline;
  }
`;

const Transition: any = React.forwardRef<unknown, SlideProps>((props, ref) => {
  return <Slide direction="right" timeout={1000} mountOnEnter unmountOnExit ref={ref} {...props} />;
});

const LISTBOX_PADDING = 8;

function renderRow(renderRowProps: any) {
  const { data, index, style } = renderRowProps;
  return React.cloneElement(data[index], {
    style: {
      ...style,
      top: style.top + LISTBOX_PADDING,
    },
  });
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((OuterElementprops: any, ref: any) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...OuterElementprops} {...outerProps} />;
});

function useResetCache(data: any) {
  const ref = React.useRef<any>(null);
  React.useEffect(() => {
    if (ref != null && ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const SelectComponent: any = React.forwardRef(function ListboxComponent(props: any, ref: any) {
  const { children, ...other } = props;
  const itemData = React.Children.toArray(children);
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;

  const getChildSize = (child: any) => {
    if (React.isValidElement(child) && child.type === ListSubheader) {
      return 48;
    }

    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

SelectComponent.propTypes = {
  children: PropTypes.node,
};

const useStyles = makeStyles({
  dialog: {
    maxWidth: '50vw',
  },
  listbox: {
    // tslint:disable-next-line: object-literal-key-quotes
    boxSizing: 'border-box',
    '& ul': {
      padding: 0,
      margin: 0,
    },
  },
});

/**
 * check if the file needs to be downloaded from storage bucket
 * or rely on the file url, directly.
 */

const AIEarthAirTab: React.FC<
  IAiEarthTab & {
    context: IAuthContext;
  }
> = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { ProgramQuery, searchTerm, setSearchTerm } = props;
  const store: any = useSelector<any>((state): any => state);
  const aiEarthState: IAIEarth = store.aiearth;
  const aiEarthMapState: IMap = store.map;
  const aiAirState: IAir = store.air;
  const [airSearch, setAirSearch] = useState('keyword');
  const [latestEmissionEventsPopover, setLatestEmissionEventsPopover] = useState(false);
  const [showPopups, setShowPopups] = useState(localStorage.getItem('airPopups') === 'yes' ? true : false);
  const [twitterPopover, setTwitterPopover] = useState(false);
  const [texasNewsRSSPopover, setTexasNewsRSSPopover] = useState(false);
  const [latestEventsPopover, setLatestEventsPopover] = useState(false);
  const [emissionsPopover, setEmissionsPopover] = useState(false);
  const [aqiPopover, setAQIPopover] = useState(false);
  const [twitterTweets, setTwitterTweets] = useState<any>();
  const [texasNewsRSS, setTexasNewsRSS] = useState<any>();
  const [latestEmissionEvents, setLatestEmissionEvents] = useState<any>();
  const [latestRNEmissionEvents, setLatestRNEmissionEvents] = useState<any>();
  const [airQualityIndex, setAirQualityIndex] = useState<any>();
  const [airEmissions, setAirEmissions] = useState<any>();
  const [searchRecords, setSearchRecords] = useState<any>({});
  const [getSelectFacility, setSelectFacility] = useState<string>('');

  useEffect(() => {
    props.getAirLists();
    if (!latestEmissionEvents) {
      getInitialPopups();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const doTextSearch = (queryText: string = '', from = 0) => {
    // Track search event
    ReactGA.event({
      category: 'Search',
      action: 'Search Ai-Air Query',
      label: queryText
    });
    dispatch(
      updateAIEarth({
        ...aiEarthState,
        ...{ isLoading: true },
      })
    );
    return search(applyFilterToQuery({ query: { from, text: queryText, size: 10 } }, { category: 'Air' }))
      .then((result: any) => {
        const data = result.data as IElasticResult<ISearchRecord>;
        const epnArray: any[] = [];
        const filteredRecords = R.uniqBy(R.prop('entityNumber'), data.records)
          .filter((ele: ISearchRecord) => {
            return ele.entityNumber !== null;
          })
          .map((ele: ISearchRecord) => {
            if (ele.location.geomz) {
              const decryptedData = CryptoJS.AES.decrypt(ele.location.geomz, secKey, {
                iv,
                mode: CryptoJS.mode.CBC,
              }).toString(CryptoJS.enc.Utf8);
              const latLon = decryptedData.split(',');
              ele.location.lon = parseFloat(latLon[0]);
              ele.location.lat = parseFloat(latLon[1]);
            }
            if (ele.location.geom_json) {
              for (const epnKey in ele.location.geom_json) {
                if (ele.location.geom_json.hasOwnProperty(epnKey)) {
                  for (const epnInnerKey in ele.location.geom_json[epnKey]) {
                    if (ele.location.geom_json[epnKey].hasOwnProperty(epnInnerKey)) {
                      const element = ele.location.geom_json[epnKey][epnInnerKey];
                      const epnRecord: any = {};
                      if (element.geom) {
                        const decryptedData = CryptoJS.AES.decrypt(element.geom, secKey, {
                          iv,
                          mode: CryptoJS.mode.CBC,
                        }).toString(CryptoJS.enc.Utf8);
                        const latLon = decryptedData.split(',');
                        epnRecord.location = Object.assign({});
                        epnRecord.location.lon = parseFloat(latLon[0]);
                        epnRecord.location.lat = parseFloat(latLon[1]);
                        epnRecord.marker = element.marker;
                        epnRecord.name = element.name;
                        epnRecord.type = element.type;
                        epnRecord.details = element.details;
                        if (ele.entityNumber) {
                          epnRecord.entityNumber = ele.entityNumber;
                          epnArray.push(epnRecord);
                        }
                      }
                    }
                  }
                }
              }
            }
            return ele;
          });
        const searchData: any = data;
        searchData.records = filteredRecords;
        searchData.epnData = epnArray;
        setSearchRecords(searchData);
        if (filteredRecords.length > 0) {
          dispatch(
            updateAir({
              ...aiAirState,
              ...{ activeRecord: filteredRecords[0] },
            })
          );
          dispatch(
            updateAIEarth({
              ...aiEarthState,
              ...{ mainDrawer: 'air', data: searchData, isLoading: false },
            })
          );
          if (filteredRecords[0].location.lat && filteredRecords[0].location.lon) {
            aiEarthMapState.gMap.setZoom(16);
            aiEarthMapState.gMap.setMapTypeId('satellite');
            getPopupsData({
              entityNumber: filteredRecords[0].entityNumber,
              latitude: filteredRecords[0].location.lat,
              longitude: filteredRecords[0].location.lon,
            });
          } else {
            aiEarthMapState.gMap.setZoom(6);
            aiEarthMapState.gMap.setMapTypeId('satellite');
            getPopupsData({
              entityNumber: filteredRecords[0].entityNumber,
              latitude: 29.0,
              longitude: -95.0,
            });
          }
        }
      })
      .catch(() => {
        dispatch(
          updateAIEarth({
            ...aiEarthState,
            ...{ isLoading: false },
          })
        );
      });
  };

  const doProgramSearch = (entityNumber: any, from = 0) => {
    const requestBody: any = {};
    dispatch(
      updateAIEarth({
        ...aiEarthState,
        ...{ isLoading: true },
      })
    );
    requestBody.entity_ids = entityNumber;

    if (props.boundingBox) {
      requestBody.bounding_box = props.coords.boundingBox;
    }
    if (from !== 0) {
      requestBody.offset = from;
    }

    try {
      axios
        .post(
          API_BASE_URL + '/api/programQuery',
          // 'http://localhost:5000/ceres-platform-test/us-central1/api/programQuery',
          requestBody,
          {
            headers: API_AUTH_HEADERS,
          }
        )
        .then((response) => {
          const resultRecords = response.data[0].query_programs.data;
          const programQueryRecords: ISearchRecord[] = [];
          const epnArray: any[] = [];

          resultRecords.forEach((record: any) => {
            const tempRecord: ISearchRecord = { ...dummyRecord };
            tempRecord.contentId = record.id;
            tempRecord.entityName = record.nm;
            tempRecord.entityNumber = record.en;
            tempRecord.entitySource = record.es;
            tempRecord.secondaryId = record.si;
            tempRecord.address = record.ad;

            if (record.gm) {
              const decryptedData = CryptoJS.AES.decrypt(record.gm, secKey, {
                iv,
                mode: CryptoJS.mode.CBC,
              }).toString(CryptoJS.enc.Utf8);
              const [lon, lat] = decryptedData.split(',');

              tempRecord.location = {
                lon: parseFloat(lon),
                lat: parseFloat(lat),
                geomz: record.geomz || '', // Ensure geomz is included
                geom_json: record.geom_json || {}, // Ensure geom_json is included
              };
            }

            if (record.geom_json) {
              Object.values(record.geom_json).forEach((geomData) => {
                Object.values(geomData as Record<string, any>).forEach((element: any) => {
                  if (element.geom) {
                    const decryptedData = CryptoJS.AES.decrypt(element.geom, secKey, {
                      iv,
                      mode: CryptoJS.mode.CBC,
                    }).toString(CryptoJS.enc.Utf8);
                    const [lon, lat] = decryptedData.split(',');
                    epnArray.push({
                      location: { lon: parseFloat(lon), lat: parseFloat(lat) },
                      marker: element.marker,
                      name: element.name,
                      type: element.type,
                      details: element.details,
                      entityNumber: element.entityNumber,
                    });
                  }
                });
              });
            }

            programQueryRecords.push(tempRecord);
          });
          const programQueryMapRecords = programQueryRecords.filter((rec) => rec.location != null);
          const data = {
            records: programQueryMapRecords,
            total: programQueryMapRecords.length,
            epnData: epnArray,
          };
          setSearchRecords(data);
          if (programQueryMapRecords.length > 0) {
            dispatch(
              updateAir({
                ...aiAirState,
                ...{ activeRecord: programQueryMapRecords[0] },
              })
            );
            dispatch(
              updateAIEarth({
                ...aiEarthState,
                ...{ mainDrawer: 'air', data, isLoading: false },
              })
            );
            aiEarthMapState.gMap.setZoom(16);
            aiEarthMapState.gMap.setMapTypeId('satellite');
            getPopupsData({
              entityNumber: programQueryMapRecords[0].entityNumber,
              latitude: programQueryMapRecords[0].location.lat,
              longitude: programQueryMapRecords[0].location.lon,
            });
          }
        })
        .catch((err) => {
          CeresLogger.error(err);
        });
    } catch (e: any) {
      CeresLogger.error(e);
    }
  };

  const getAQIData = async (airQualityData: any) => {
    const requestBody: any = {};
    requestBody.latitude = airQualityData.latitude;
    requestBody.longitude = airQualityData.longitude;
    requestBody.distance = 25;
    requestBody.date = '2020-09-24';
    requestBody.type = 'latLong';
    try {
      const aqiResponse = await axios.post(
        API_BASE_URL + '/api/getAirQualityIndex',
        requestBody,
        {
          headers: API_AUTH_HEADERS,
        }
      );
      return aqiResponse.data;
    } catch (e: any) {
      CeresLogger.error(e);
    }
  };

  const getAirEmissions = async (airQualityData: any) => {
    const requestBody: any = {};
    requestBody.RN = airQualityData.entityNumber;
    try {
      const airEmissionResponse = await axios.post(
        API_BASE_URL + '/api/airEmissionPopup',
        requestBody,
        {
          headers: API_AUTH_HEADERS,
        }
      );
      const airEmissionData = airEmissionResponse.data;
      return airEmissionData;
    } catch (e: any) {
      CeresLogger.error(e);
    }
  };

  const getTwitterTweets = async (twitterSearchTerm: string) => {
    const requestBody: any = {};
    requestBody.searchTerm = twitterSearchTerm;
    requestBody.count = 10;
    requestBody.resultType = 'mixed';
    try {
      const twitterTweetsResp = await axios.post(
        API_BASE_URL + '/api/getTwitterTweets',
        // 'http://localhost:5000/ceres-platform-test/us-central1/api/getTwitterTweets',
        requestBody,
        {
          headers: API_AUTH_HEADERS,
        }
      );
      const twitterTweetsData = twitterTweetsResp.data;
      return twitterTweetsData;
    } catch (e: any) {
      CeresLogger.error(e);
    }
  };

  const getRNLatestEmissionEvents = async (airQualityData: any) => {
    const requestBody: any = {};
    requestBody.RN = airQualityData.entityNumber;
    try {
      const latestEmissionEventsResponse = await axios.post(
        API_BASE_URL + '/api/getRNLatestEvents',
        requestBody,
        {
          headers: API_AUTH_HEADERS,
        }
      );
      let latestEmissionEventsData = null;
      if (latestEmissionEventsResponse.data && latestEmissionEventsResponse.data.length > 0) {
        latestEmissionEventsData =
          typeof latestEmissionEventsResponse.data[0].emission_events_top10_json !== 'undefined'
            ? latestEmissionEventsResponse.data[0].emission_events_top10_json
            : [];
      }
      return latestEmissionEventsData;
    } catch (e: any) {
      CeresLogger.error(e);
    }
  };

  const getPopupsData = async (airQualityData: any) => {
    if (showPopups) {
      const [aqiResult, airEmissionData, latestRNEmissionEventsData] = await Promise.all([
        getAQIData(airQualityData),
        getAirEmissions(airQualityData),
        getRNLatestEmissionEvents(airQualityData),
      ]);

      let x = 0;
      const popupInterval = setInterval(() => {
        if (++x === 4) {
          window.clearInterval(popupInterval);
          setLatestEmissionEventsPopover(false);
        }
        if (x === 1) {
          if (airEmissionData.length > 0) {
            setAirEmissions(airEmissionData[0].aai_emission_popup);
            setEmissionsPopover(true);
          }
        } else if (x === 2) {
          setEmissionsPopover(false);
          if (aqiResult && aqiResult.length > 0) {
            setAirQualityIndex(aqiResult);
            setAQIPopover(true);
          }
        } else if (x === 3) {
          setAQIPopover(false);
          if (latestRNEmissionEventsData && latestRNEmissionEventsData.length > 0) {
            setLatestRNEmissionEvents(latestRNEmissionEventsData);
            setLatestEmissionEventsPopover(true);
          }
        }
      }, 3000);
    }
  };

  const getInitialPopups = async () => {
    if (showPopups) {
      const [latestEmissionEventsData, rssNewsResponse, twitterTweetsData] = await Promise.all([
        getLatestEmissionEvents(),
        getTexasEnvNews(),
        getTwitterTweets(
          'texas+environment OR texas+pollution OR texas+petroleum OR texas+refinery OR texas+contamination'
        ),
      ]);
      let x = 0;
      const popupInterval = setInterval(() => {
        if (++x === 4) {
          window.clearInterval(popupInterval);
          setTwitterPopover(false);
        }
        if (x === 1) {
          if (latestEmissionEventsData && latestEmissionEventsData.length > 0) {
            setLatestEmissionEvents(latestEmissionEventsData);
            setLatestEventsPopover(true);
          }
        } else if (x === 2) {
          setLatestEventsPopover(false);
          if (rssNewsResponse != null) {
            const parser = new Parser();
            parser.parseString(rssNewsResponse, (error, feed: any) => {
              if (feed && feed.items.length > 0) {
                setTexasNewsRSS(feed.items);
                setTexasNewsRSSPopover(true);
              }
            });
          }
        } else if (x === 3) {
          setTexasNewsRSSPopover(false);
          if (twitterTweetsData != null) {
            if (twitterTweetsData.statuses && twitterTweetsData.statuses.length > 0) {
              setTwitterTweets(twitterTweetsData.statuses);
              setTwitterPopover(true);
            }
          }
        }
      }, 3000);
    }
  };

  const getLatestEmissionEvents = async () => {
    try {
      const latestEmissionEventsResponse = await axios.get(
        API_BASE_URL + '/api/airLatestEvents',
        {
          headers: API_AUTH_HEADERS,
        }
      );
      let latestEmissionEventsData = null;
      if (latestEmissionEventsResponse.data) {
        latestEmissionEventsData = latestEmissionEventsResponse.data[0].jsonlistb;
      }
      return latestEmissionEventsData;
    } catch (e: any) {
      CeresLogger.error(e);
    }
  };

  const getTexasEnvNews = async () => {
    try {
      const airTexasLatestNewsResponse = await axios.get(
        API_BASE_URL + '/api/airTexasLatestNews',
        {
          headers: API_AUTH_HEADERS,
        }
      );
      return airTexasLatestNewsResponse.data;
    } catch (e: any) {
      CeresLogger.error(e);
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (key?: string) => {
    setAnchorEl(null);
    if (key === 'LatestTexasEmissionEvents') {
      setLatestEventsPopover(true);
    }
    if (key === 'TexasEnvironmentalSocialMedia') {
      setTwitterPopover(true);
    }
    if (key === 'TexasEnvironmentalNews') {
      setTexasNewsRSSPopover(true);
    }
    if (key === 'EmissionsProfileFacility') {
      setEmissionsPopover(true);
    }
    if (key === 'AirQualityFacility') {
      setAQIPopover(true);
    }
    if (key === 'LatestEmissionsFacility') {
      setLatestEmissionEventsPopover(true);
    }
  };

  const totalRecords = searchRecords.total;
  return (
    <Fragment>
      <AirContainer>
        <PopupContainer>
          <FormControlLabel
            className="cmn-air-popup-label"
            control={
              <Switch
                className="cmn-air-popup-switch"
                checked={showPopups}
                onChange={() => {
                  setShowPopups(!showPopups);
                  localStorage.setItem('airPopups', showPopups ? 'no' : 'yes');
                }}
              />
            }
            label="Show Popups"
          />
          <Button aria-controls="fade-menu" aria-haspopup="true" onClick={handleClick}>
            <AnnouncementIcon />
          </Button>
        </PopupContainer>
        <Menu
          id="fade-menu"
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          getContentAnchorEl={null}
          keepMounted
          open={open}
          onClose={() => {
            handleClose();
          }}
          TransitionComponent={Fade}
        >
          {latestEmissionEvents && (
            <MenuItem
              onClick={() => {
                handleClose('LatestTexasEmissionEvents');
              }}
            >
              Latest Texas Emission Events
            </MenuItem>
          )}
          {texasNewsRSS && (
            <MenuItem
              onClick={() => {
                handleClose('TexasEnvironmentalNews');
              }}
            >
              Texas Environmental News
            </MenuItem>
          )}
          {twitterTweets && (
            <MenuItem
              onClick={() => {
                handleClose('TexasEnvironmentalSocialMedia');
              }}
            >
              Social Media
            </MenuItem>
          )}
          {airEmissions && (
            <MenuItem
              onClick={() => {
                handleClose('EmissionsProfileFacility');
              }}
            >
              Emissions Profile for the Facility
            </MenuItem>
          )}
          {airQualityIndex && (
            <MenuItem
              onClick={() => {
                handleClose('AirQualityFacility');
              }}
            >
              Air Quality for the Facility
            </MenuItem>
          )}
          {latestRNEmissionEvents && (
            <MenuItem
              onClick={() => {
                handleClose('LatestEmissionsFacility');
              }}
            >
              Latest Emissions for the Facility
            </MenuItem>
          )}
        </Menu>
        <FormControl component="fieldset">
          <FormLabel component="legend">Air Search</FormLabel>
          <RadioGroup
            row
            name="airSearch"
            value={airSearch}
            onChange={(e) => {
              setAirSearch(e.target.value);
              setSearchRecords({});
              setSearchTerm('');
              setLatestRNEmissionEvents(null);
              setAirQualityIndex(null);
              setAirEmissions(null);
              dispatch(
                updateAIEarth({
                  ...aiEarthState,
                  ...{
                    mainDrawer: '',
                    subDrawer: '',
                    data: null,
                  },
                })
              );
              if (aiEarthState.mainDrawer !== '') {
                aiEarthMapState.gMap.setZoom(5);
              }
              aiEarthMapState.gMap.setMapTypeId('roadmap');
            }}
          >
            <FormControlLabel
              className={`cmn-air-pill-option ${airSearch === 'facility' ? 'cmn-air-pill-option--active' : ''}`}
              value="facility"
              control={<Radio size="small" />}
              label={<span className="cmn-air-pill-option__label">Facility</span>}
              onChange={(e: any) => {
                props.setBoundingBox(false);
              }}
            />
            <FormControlLabel
              className={`cmn-air-pill-option ${airSearch === 'keyword' ? 'cmn-air-pill-option--active' : ''}`}
              value="keyword"
              control={<Radio size="small" />}
              label={<span className="cmn-air-pill-option__label">Keyword</span>}
              onChange={(e: any) => {
                props.setBoundingBox(false);
              }}
            />
            <FormControlLabel
              className={`cmn-air-pill-option ${props.boundingBox ? 'cmn-air-pill-option--active' : ''}`}
              value="boundingBox"
              control={<Radio size="small" />}
              label={<span className="cmn-air-pill-option__label">Bounding Box</span>}
              name="boundingBox"
              checked={props.boundingBox}
              onChange={(e: any) => {
                props.setBoundingBox(true);
                aiEarthMapState.gMap.panTo({ lat: 31, lng: -100 });
              }}
            />
          </RadioGroup>
        </FormControl>
        {airSearch === 'facility' && (
          <Autocomplete
            size="small"
            value={getSelectFacility}
            disabled={aiEarthState.isLoading}
            ListboxComponent={SelectComponent}
            onChange={(e: any, value: any) => {
              if (value) {
                const rnNumber = value.split('-')[2];
                doProgramSearch(rnNumber);
                props.setActiveTabDrawer('permits');
              }
            }}
            options={aiEarthState.airListOptions ? aiEarthState.airListOptions : []}
            renderInput={(params) => <TextField {...params} variant="outlined" label="Facilities" />}
            renderOption={(option: any) => <TypographyCustom>{option}</TypographyCustom>}
          />
        )}
        {airSearch === 'keyword' && (
          <>
            <TextField
              className="cmn-air-keyword-input"
              variant="outlined"
              label="Keyword"
              value={searchTerm}
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={(e) => {
                        doTextSearch(searchTerm);
                        props.setActiveTabDrawer('permits');
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              disabled={aiEarthState.isLoading}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              onKeyPress={(event: any) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  doTextSearch(searchTerm);
                  props.setActiveTabDrawer('permits');
                }
              }}
            />
          </>
        )}
        {props.boundingBox && (
          <>
            <BoundingBox>Air Facilities intersecting the bounding box</BoundingBox>
            <ProgramQuery />
          </>
        )}
        {aiEarthState.isLoading && <LinearProgress />}
        {(airSearch === 'keyword' || airSearch === 'facility') && (
          <SearchResultContainer>
            <Scrollbars className="cmn-scroll-h-340">
              {searchRecords.records && (
                <RecordsContainer>
                  {R.compose<any[], any[], any[]>(
                    R.map((record: ISearchRecord) => {
                      return (
                        <OverlayTrigger
                          key={record.contentId}
                          trigger="hover"
                          placement="bottom"
                          overlay={
                            <ReactTooltip effect="solid" html={true} />
                          }
                        >
                          <Button
                            className={`cmn-record-btn ${
                              aiAirState.activeRecord.entityNumber === record.entityNumber
                                ? 'cmn-record-btn-active'
                                : 'cmn-record-btn-default'
                            }`}
                            data-tip={
                              ReactDOMServer.renderToString(
                                <div>
                                  <strong>{record.entityNumber}</strong>
                              <br />
                              {record.cityName}
                                </div>
                              )
                            }
                            onClick={(e: any) => {
                              dispatch(
                                updateAir({
                                  ...aiAirState,
                                  ...{ activeRecord: record },
                                })
                              );
                              dispatch(
                                updateAIEarth({
                                  ...aiEarthState,
                                  ...{ mainDrawer: 'air' },
                                })
                              );

                              if (record.location && typeof record.location.lat !== 'undefined') {
                                aiEarthMapState.gMap.setZoom(16);
                                getPopupsData({
                                  entityNumber: record.entityNumber,
                                  latitude: record.location.lat,
                                  longitude: record.location.lon,
                                });
                                aiEarthMapState.gMap.setMapTypeId('satellite');
                              } else {
                                aiEarthMapState.gMap.setZoom(6);
                                getPopupsData({
                                  entityNumber: record.entityNumber,
                                  latitude: 29.0,
                                  longitude: -95.0,
                                });
                                aiEarthMapState.gMap.setMapTypeId('satellite');
                              }
                            }}
                            size="sm"
                            block={true}
                          >
                            {record.entityName || record.entityNumber}
                          </Button>
                        </OverlayTrigger>
                      );
                    }),
                    R.filter((record: any) => {
                      return record.entityName || record.entityNumber;
                    })
                  )(searchRecords.records)}
                  {totalRecords && (
                    <SearchPagination
                      isDisabled={false}
                      isFirstPage={(searchRecords && searchRecords.from === 0) || false}
                      isLastPage={(searchRecords && searchRecords.from + searchRecords.size >= totalRecords) || false}
                      totalRecords={totalRecords}
                      onPreviousClick={() => {
                        if (!searchRecords) {
                          return;
                        }
                        const currentFrom = searchRecords.from;
                        const currentSize = searchRecords.size;
                        return doTextSearch(searchTerm, currentFrom - currentSize);
                      }}
                      onNextClick={() => {
                        if (!searchRecords) {
                          return;
                        }
                        const currentFrom = searchRecords.from;
                        const currentSize = searchRecords.size;
                        return doTextSearch(searchTerm, currentFrom + currentSize);
                      }}
                    />
                  )}
                </RecordsContainer>
              )}
            </Scrollbars>
          </SearchResultContainer>
        )}
        <Dialogs
          TransitionComponent={Transition}
          onClose={() => {
            setEmissionsPopover(false);
          }}
          open={emissionsPopover}
        >
          <PopoverContainer>
            <NewsHeader>Emissions Profile</NewsHeader>
            <Table bordered>
              <tbody>
                {airEmissions && (
                  <>
                    <EmissionTR>
                      <CenterTD>Current Emissions Level</CenterTD>
                      <td>
                        {airEmissions.current_hourly_emissions_criteria_pounds}{' '}
                        {airEmissions.current_hourly_emissions_criteria_pounds !== '-'
                          ? 'lbs/hr(criteria pollutants)'
                          : ''}
                      </td>
                      <FixedTD>
                        {airEmissions.current_emissions_rank !== '-' ? 'Rank #' : ''}
                        {airEmissions.current_emissions_rank}
                      </FixedTD>
                    </EmissionTR>
                    <EmissionTR>
                      <CenterTD rowSpan={2}>Annual Emissions</CenterTD>
                      <td>
                        {airEmissions.annual_emissions_criteria_rank !== '-' && (
                          <Link to={'/benchmarking?rn=' + aiAirState.activeRecord.entityNumber + '&event=2'}>
                            {airEmissions.annual_emissions_criteria_rank}
                            {' tons (criteria pollutants)'}
                          </Link>
                        )}
                        {airEmissions.annual_emissions_criteria_rank === '-' && '-'}
                      </td>
                      <FixedTD>
                        {airEmissions.current_emissions_rank !== '-' ? 'Rank #' : ''}
                        {airEmissions.current_emissions_rank}
                      </FixedTD>
                    </EmissionTR>
                    <EmissionTR>
                      <td>
                        {airEmissions.annual_emissions_co2e_tons !== '-' && (
                          <Link to={'/benchmarking?rn=' + aiAirState.activeRecord.entityNumber + '&event=2'}>
                            {airEmissions.annual_emissions_co2e_tons}
                            {' tons (coe2)'}
                          </Link>
                        )}
                        {airEmissions.annual_emissions_co2e_tons === '-' && '-'}
                      </td>
                      <FixedTD>
                        {airEmissions.annual_emissions_co2e_rank !== '-' ? 'Rank #' : ''}
                        {airEmissions.annual_emissions_co2e_rank}
                      </FixedTD>
                    </EmissionTR>
                    <EmissionTR>
                      <CenterTD>Unauthorized Emissions since 2004</CenterTD>
                      <td>
                        {airEmissions.unauthorized_emissions_tons !== '-' && (
                          <Link to={'/benchmarking?rn=' + aiAirState.activeRecord.entityNumber + '&event=1'}>
                            {airEmissions.unauthorized_emissions_tons}
                            {' tons'}
                          </Link>
                        )}
                        {airEmissions.unauthorized_emissions_tons === '-' && '-'}
                      </td>
                      <FixedTD>
                        {airEmissions.unauthorized_emissions_rank !== '-' ? 'Rank #' : ''}
                        {airEmissions.unauthorized_emissions_rank}
                      </FixedTD>
                    </EmissionTR>
                    <EmissionTR>
                      <CenterTD>Uncontrolled / Undercontrolled Emissions (NOx and VOC)</CenterTD>
                      <td>
                        {airEmissions.uncontrolled_emissions_tons !== '-' && (
                          <Link to={'/generator?rn=' + aiAirState.activeRecord.entityNumber}>
                            {airEmissions.uncontrolled_emissions_tons}
                            {' tons'}
                          </Link>
                        )}
                        {airEmissions.uncontrolled_emissions_tons === '-' && '-'}
                      </td>
                      <FixedTD>
                        {airEmissions.uncontrolled_emissions_rank !== '-' ? 'Rank #' : ''}
                        {airEmissions.uncontrolled_emissions_rank}
                      </FixedTD>
                    </EmissionTR>
                  </>
                )}
              </tbody>
            </Table>
          </PopoverContainer>
        </Dialogs>
        <Dialogs
          TransitionComponent={Transition}
          onClose={() => {
            setAQIPopover(false);
          }}
          open={aqiPopover}
        >
          <PopoverContainer>
            <NewsHeader>
              <a
                className="cmn-pointer"
                href={
                  airQualityIndex &&
                  'https://www.airnow.gov/?city=' +
                    airQualityIndex[0].ReportingArea +
                    '&state=' +
                    airQualityIndex[0].StateCode +
                    '&country=USA'
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                Today's Air Quality for this Facility
              </a>
            </NewsHeader>
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th>AQI</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {airQualityIndex && (
                  <>
                    {airQualityIndex[0] && (
                      <tr>
                        <td>{airQualityIndex[0].ParameterName}</td>
                        <td>{airQualityIndex[0].AQI}</td>
                        <td>{airQualityIndex[0].Category.Name}</td>
                      </tr>
                    )}
                    {airQualityIndex[1] && (
                      <tr>
                        <td>{airQualityIndex[1].ParameterName}</td>
                        <td>{airQualityIndex[1].AQI}</td>
                        <td>{airQualityIndex[1].Category.Name}</td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </Table>
          </PopoverContainer>
        </Dialogs>
        <Dialogs
          TransitionComponent={Transition}
          onClose={() => {
            setLatestEmissionEventsPopover(false);
          }}
          open={latestEmissionEventsPopover}
        >
          <PopoverContainer>
            <NewsHeader
              className="cmn-link-underline-pointer"
              onClick={() => {
                if (aiAirState.activeRecord.entityNumber) {
                  doProgramSearch(aiAirState.activeRecord.entityNumber);
                  setAirSearch('facility');
                  setSelectFacility(aiAirState.activeRecord.entityName + '-' + aiAirState.activeRecord.entityNumber);
                  props.setActiveTabDrawer('emissionEvents');
                  setLatestEmissionEventsPopover(false);
                }
              }}
            >
              Latest Emission Events for this Facility
            </NewsHeader>
            <Table bordered hover>
              <tbody>
                {latestRNEmissionEvents &&
                  latestRNEmissionEvents.map((event: any) => {
                    return (
                      <>
                        <tr>
                          <td>{event.date}</td>
                          <td>{event.amount} lbs</td>
                          <td>{event.duration}</td>
                        </tr>
                      </>
                    );
                  })}
              </tbody>
            </Table>
          </PopoverContainer>
        </Dialogs>
        <Dialogs
          classes={{
            paper: classes.dialog,
          }}
          TransitionComponent={Transition}
          onClose={() => {
            setLatestEventsPopover(false);
          }}
          open={latestEventsPopover}
        >
          <PopoverContainer>
            <NewsHeader>The Latest Texas Emission Events</NewsHeader>
            <Table bordered hover>
              <tbody>
                {latestEmissionEvents &&
                  latestEmissionEvents.map((event: any, index: number) => {
                    return (
                      <tr key={index}>
                        <td>
                          <a
                            href="#/"
                            onClick={() => {
                              doProgramSearch(event.rn_number);
                              setAirSearch('facility');
                              setSelectFacility(event.rn_name + '-' + event.customer_name + '-' + event.rn_number);
                              props.setActiveTabDrawer('emissionEvents');
                              setLatestEventsPopover(false);
                            }}
                            title={event.rn_name}
                          >
                            {event.rn_name}
                          </a>
                        </td>
                        <td>{event.amount} lbs</td>
                        <td>{event.date}</td>
                        <td>{event.duration}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </PopoverContainer>
        </Dialogs>
        <Dialogs
          classes={{
            paper: classes.dialog,
          }}
          TransitionComponent={Transition}
          onClose={() => {
            setTexasNewsRSSPopover(false);
          }}
          open={texasNewsRSSPopover}
        >
          <PopoverContainer>
            <NewsHeader>
              <a href="http://www.texasenvironmentalnews.com" target="_blank" rel="noopener noreferrer">
                Texas Environmental News
              </a>
            </NewsHeader>
            <Divider />
            {texasNewsRSS &&
              texasNewsRSS.map((news: any, index: number) => {
                return (
                  <div key={index}>
                    <h6>
                      <a href={news.link} rel="noopener noreferrer" target="_blank">
                        {news.title}
                      </a>
                    </h6>
                    <p>
                      {news.contentSnippet.split('[...]')[0].split('…Read Full Article Source')[0]}
                      <a href={news.link} rel="noopener noreferrer" target="_blank">
                        ...Read More
                      </a>
                    </p>
                    <Divider />
                  </div>
                );
              })}
          </PopoverContainer>
        </Dialogs>
        <Dialogs
          TransitionComponent={Transition}
          onClose={() => {
            setTwitterPopover(false);
          }}
          open={twitterPopover}
        >
          <PopoverContainer>
            <NewsHeader>Texas Environmental Social Media</NewsHeader>
            <Divider />
            <Scrollbars className="cmn-scroll-h-200">
              <TweetContainer>
                {twitterTweets &&
                  twitterTweets.map((tweet: any, index: number) => {
                    return (
                      <div key={index}>
                        <h6>
                          <a
                            href={`https://twitter.com/i/web/status/${tweet.id_str}`}
                            rel="noopener noreferrer"
                            target="_blank"
                            dangerouslySetInnerHTML={{ __html: tweet.text }}
                          ></a>
                        </h6>
                        <TwitterTweetEmbed tweetId={tweet.id_str} />
                        <Divider />
                      </div>
                    );
                  })}
              </TweetContainer>
            </Scrollbars>
          </PopoverContainer>
        </Dialogs>
      </AirContainer>
    </Fragment>
  );
};

export default withAuthContext(AIEarthAirTab);
